<template>
    <card>
        <template slot="header">
            <h3 class="card-title">Upload Payslip</h3>
        </template>
        <div class="row">
            <nav>
                <ol class="breadcrumb arr-right bg-breadcrum">
                    <li class="breadcrumb-item">
                        <router-link to="/hr/dashboard"><i class="fa fa-home"></i>&nbsp;Dashboard</router-link>
                    </li>
                    <li class="breadcrumb-item">
                      <router-link to="/hr/payslip/">Employee Payslip</router-link>
                    </li>
                    <li class="breadcrumb-item active">Upload Payslip</li>
                </ol>
            </nav>
        </div>
        <hr style="margin-top:-10px" />
         <br/>
           <div class="col-md-12">
                      <font color="#4285f4" class="title-section"><i class="fa fa-info-circle"></i> Employee Information</font>
                    <br/>
            <div class="payslip-border">
                <div class="row">
                    <p class="col-md-3 text-right p-text"><b>Employee Name</b></p>
                        <div class="col-md-6">
                            <input type="text" :value="item.full_name" class="form-control" disabled>
                        </div>
                </div>

                <div class="row">
                    <p class="col-md-3 text-right p-text"><b>Employee No </b></p>
                    <div class="col-md-6">
                          <input type="text" :value="item.emp_id" class="form-control" disabled>
                    </div>
                </div>

                <div class="row">
                    <p class="col-md-3 text-right p-text"><b>Position</b></p>
                    <div class="col-md-6">
                         <input type="text" :value="item.position_name" class="form-control" disabled>
                    </div>
                </div>

                <div class="row">
                    <p class="col-md-3 text-right p-text"><b>Department</b></p>
                    <div class="col-md-6">
                        <input type="text" :value="item.department_name" class="form-control" disabled>
                    </div>
                </div>

                <div class="row">
                    <p class="col-md-3 text-right p-text"><b>Date Hired</b></p>
                    <div class="col-md-6">
                        <input type="text" :value="item.employment_date" class="form-control" disabled>
                    </div>
                </div>
            </div>  
            <br/>  
              <div class="col-md-12">
                  <div class="row alert alert-info" role="alert">
                      <p class="pt-2"><i class="fa fa-info-circle"></i>Notes: Upload generated payslip PDFs with the correct pay date to ESS system so employees can securely view and download their payslips online. </p>
                  </div>
              </div> 
            <font color="#4285f4" class="title-section"><i class="fa fa-table"></i> Upload Payslip</font><font size="2" color="red" class="float-right">(*) All Fields Are Required</font>    
         <div class="payslip-border">
              
             <form @submit.prevent="uploadPayslip">
                  <div class="row">
                        <p class="col-md-3 text-right p-text"></p>
                        <div class="col-md-6">
                            Upload Payslip for <b>{{item.full_name}}</b>
                        </div>
                    </div>
                   <div class="row">
                        <p class="col-md-3 text-right p-text"><b>Pay Date</b></p>
                        <div class="col-md-6">
                            <input type="date" 
                                  v-model="pay_date" 
                                  class="form-control" 
                                  :class="{ 'is-invalid': error_handler && error_handler.pay_date }">

                            <span v-if="error_handler && error_handler.pay_date"
                                  class="invalid-feedback d-block">
                                {{ error_handler.pay_date[0] }}
                            </span>
                        </div>
                    </div>
                    <!-- Attach File -->
                      <div class="form-group row">
                           <div class="col-sm-3">
                              <label class="float-right mt-2"><b>Attach Payslip</b></label>
                           </div>
                            <div class="col-sm-3">
                              <label for="docFileUpload" class="custom-file-upload"> <i class="fa fa-upload"></i>Upload file</label>
                              <input type="file" id="docFileUpload"  @change="payslipFiles">
                            <span v-for="item in error_handler.files">
                                <li class="invalid-feedback d-block">{{item}}</li>
                            </span>
                          </div>
                          <div class="col-sm-2 mt-2">
                            <template v-if="files != ''">           
                                <div class="gallery-item">
                                  <div class="gallery-caption">
                                      <span v-if="docFileName" class="text-black">{{docFileName}}</span><br/>
                                      <span v-if="docFileSize" class="text-black-50">{{docFileSize}} KB</span> &nbsp;
                                      <button type="button" class="btn btn-xs btn-default"  @click="removePayslipFiles"><i class="fa fa-trash text-black"></i></button>
                                  </div>
                                </div>
                            </template>
                            <template v-else>
                                  <p>No file selected.</p>
                            </template>
                          </div>
                      </div>
                      <!-- End Attach File -->
                      <div class="row">
                        <div class="col-md-12">
                            <button class="btn btn-primary float-right"><i class="fa fa-paper-plane"></i>&nbsp;Submit Payslip</button>
                        </div>
                      </div>
            </form>
         </div>
         <br/>   
            <font color="#4285f4" class="title-section"><i class="fa fa-list"></i> Payslip History</font>
            <div class="payslip-border">
                 <div class="row">
                    <div class="col-md-2">
                       <p><i class="fa fa-filter"></i> Filter By Year</p>
                        <select v-model="filter_by_year" @change="getYear" class="form-control" required>
                            <option v-for="year in years(2019)">{{ year }}</option>
                        </select>
                     </div>
                    <div class="col-md-2">
                        <div class="form-group">
                            <p><i class="fa fa-sort-numeric-asc"></i>&nbsp;Display</p>
                            <select v-model="page_limit" class="form-control" required>
                                <option value="">Default</option>
                                <option value="2">2</option>
                                <option value="10">10</option>
                                <option value="25">25</option>
                                <option value="50">50</option>

                                <option value="100">100</option>
                                <option value="500">500</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-md-2">
                        <div class="form-group">
                            <p><i class="fa fa-sort-amount-asc"></i>&nbsp;Order by </p>
                            <select v-model="order_by" class="form-control" required>
                                <option value="">Default</option>
                                <option value="1">ASC</option>
                                <option value="-1">DESC</option>
                            </select>
                        </div>
                    </div>     
                </div>
             <div class="table-responsive ">
                <table class="table table-striped table-hover ">
                    <tbody>
                        <tr v-for="item,index in computedRequest">
                        <td>
                            <template v-if="item.status ==='1'">
                                <div class="row">
                                     <div class="col-md-6">
                                       <b><i class="fa fa-star" style="color:darkorange"></i> &nbsp;&nbsp; Payslip sent to {{item.full_name}},  Pay Date for {{getDate(item.pay_date)}}</b>
                                     </div>
                                     <div class="col-md-5">
                                         <span class="float-right">
                                          <a :href="'https://endpoint.blueprintbusinesssolutionscorp.com/payslip/' + item.files" target="_blank" class="btn btn-primary btn-sm">
                                            View Payslip
                                          </a>
                                        </span>
                                     </div>
                                     <div class="col-md-1">
                                        <span class="float-right"><small>{{getDate(item.created_at)}}</small></span>
                                     </div>
                                </div>
                            </template>
                            <template v-else-if="item.status='2'">
                                <div class="row">
                                     <div class="col-md-6">
                                       <i class="fa fa-star-o" style="color:darkorange"></i> &nbsp;&nbsp; Payslip sent to {{item.full_name}},  Pay Date for {{getDate(item.pay_date)}} 
                                     </div>
                                     <div class="col-md-5">
                                        <span class="float-right">
                                          <a :href="'https://endpoint.blueprintbusinesssolutionscorp.com/payslip/' + item.files" target="_blank" class="btn btn-primary btn-sm">
                                             View Payslip
                                          </a>
                                        </span>
                                     </div>
                                      <div class="col-md-1">
                                          <span class="float-right"><small>{{getDate(item.created_at)}}</small></span>
                                     </div>
                                </div>
                            </template>
                        </td>
                        <td><button class="btn btn-xs btn-danger float-right" @click="removePayslip(item.id)"><i class="fa fa-times"></i></button></td>   
                    </tr>
                    </tbody>
                </table>
                <br/>
                <!-- PAGINATION NATIVE WAY -->
                    <div class="row">
                        <div class="col-md-6">
                        <p style="color:#9a9a9a">Page {{curentPage}} out of {{total_item}} records</p>
                        </div>
                        <div class="col-md-6">
                        <b-pagination
                            v-model="curentPage"
                            :total-rows="items.length"
                            :per-page="perPage"
                            aria-controls="my-table"
                            align="right"
                            first-text="First"
                            prev-text="Prev"
                            next-text="Next"
                            last-text="Last"
                            ></b-pagination>
                        </div>
                    </div>
                  <!-- END PAGINATION -->
             </div>  
            </div>
         </div>
         <hr style="margin-top:50px" />
    </card>
  </template>
  <script>
  /* eslint-disable */
  import Card from 'src/components/UIComponents/Cards/Card.vue'
  export default {
    components: {
      Card
    },
    data() {
      return {
           item: {}, 
           error_handler:[],
           pay_date:"",

           docFileName:'',
           docFileSize:0,
           files:'',

            //PAGINATION
            page_limit: '',
            filter_by_year:'',
            order_by:'',
            start_page: 1,
            loading: true,
            perPage: 50,
            curentPage: 1,
            search: '',

            items: [],
        }
    },
    created() {
      this.getInfo()
      this.get_payslip()
    },
    methods: {

      frontEndDateFormat: function(date) {
        return moment(date, "YYYY-MM-DD").format("YYYY-MM-DD")
      },

     /*
      |----------------------------------------------------------------------
      |  TO SUBMIT FORM 
      |----------------------------------------------------------------------
      */
     uploadPayslip(){
          this.$swal({
                title: 'Are you sure?',
                text: 'Do you want to submit this payslip',
                type: 'warning',
                showCancelButton: true,
                showCloseButton: false,
              })
             
              .then((isConfirm) => {
                    if(isConfirm === true) {
                       let formData = new FormData();
                       formData.append('employee_id', this.item.id)
                       formData.append('pay_date', this.frontEndDateFormat(this.pay_date))
                       formData.append('files', this.files)
                       axios.post('api/upload/payslip', formData)
                            .then(resp=> {
                              if(resp.data.response == "success"){
                                this.$swal({
                                  type: 'success',
                                  title: 'Submitted',
                                  html: 'Payslip has been successfully uploaded. <br/><br/><br/><br/>',
                                  showConfirmButton: false,
                                  timer: 5000
                                })
                                 setTimeout(() => { 
                                    // this.$router.push({ name: 'payslip'})
                                    this.get_payslip()
                                 }, 3000);
                              }else if(resp.data.response == "error"){
                                  this.$swal('Opps',resp.data.message, 'error')
                              }  
                          })    
                          .catch(error => {
                             console.log(JSON.stringify(error.response.data.errors))
                              if (error.response.status == 422) {
                                    this.error_handler = error.response.data.errors
                              }   
                          }); 
                      }
                });
           },

           removePayslip(id){
                 this.$swal({
                    title: 'Are you sure?',
                    text: 'You can\'t revert your action',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes Delete it!',
                    cancelButtonText: 'No, Keep it!',
                    showCloseButton: false,
                    showLoaderOnConfirm: true,
                  }).then((isConfirm) => {
                       if (isConfirm === true) {
                        axios
                        .delete('api/payslip/' + id + '/delete')
                        .then(() => {
                            this.get_payslip()
                            this.$swal('Deleted!', 'The payslip has been deleted.', 'success');
                        })
                        .catch(error => {
                            console.error(error);
                            this.$swal('Error', 'Failed to delete record.', 'error');
                        });
                    }
                });
            },

        getInfo() {
            axios.get('api/contractsmemo/getinfo/' + this.$route.params.id)
                .then(resp => { this.item = resp.data})
        },

         getYear(){
            if(this.filter_by_year == ''){
                this.get_payslip()
            }else{
                  axios.get('api/employee/' + this.$route.params.id + '/payslip/' + this.filter_by_year)
                .then(response => {
                    this.items = response.data;
                    console.log('response => ',this.items)
                })
                .catch(error => {
                    console.log(error.response)
                });
            } 
          },

        get_payslip() {
            axios.get('api/employee/' + this.$route.params.id + '/payslip')
            .then(response => {
            this.items = response.data
            })
            .catch(error => {
            console.log(error.response)
            });
        },

         payslipFiles(event){
            const file = event.target.files[0]
            if(file){
               this.files = file
               this.docFileName = file.name
               this.docFileSize = (file.size / 1024).toFixed(2);
            }
         },

         removePayslipFiles(){
            this.files = ''
            this.error_handler.files = []
         },
    },
      computed: {
    // PAGINATION
    offset() {
      return ((this.start_page - 1) * this.page_limit);
    },

    limit() {
      return ((this.offset + this.page_limit));
    },
    total_item() {
           return this.items.length
    },  
    computedRequest() {
      let filtered = this.items
       // USE IN PAGINATION 
      let start = (this.curentPage - 1) * this.perPage
      let end = this.curentPage * this.perPage
      filtered = filtered.slice(start, end)
      if (filtered.length > 0) {
        // SORTING NUMBER OF DISPLAY
        if (this.page_limit) {
          filtered = filtered.slice(this.offset, this.limit);
          return filtered
        }
        // ORDER BY ASC AND DESC COMBOBOX
        if (this.order_by) {
          filtered = filtered.slice(0).sort((a, b) => a.id < b.id ? this.order_by : -this.order_by)
          return filtered
        }

      } else {
        filtered = 0
      }

      return filtered
    }
  },
  
  }
  </script>
  <style>
    input[type="file"] {
        display: none; /* Hide default file input */
    }
    .custom-file-upload {
        display: inline-block;
        background-color: #007bff;
        color: white;
        padding: 10px 15px;
        border-radius: 5px;
        cursor: pointer;
        font-weight: bold;
    }

    .custom-file-upload:hover {
        background-color: #0056b3;
    }

    .payslip-border {
        border: 1px dashed #000;
        padding: 25px;
     }
  </style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-payroll/todo-upload-payslip.vue